import { BaseInput, BaseInputConstructor } from './base-input';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type NopConstructor<T, E> = Omit<BaseInputConstructor<T>, 'label'>;

export class NopInput<T = string, E = string> extends BaseInput<T> {
	inputType = 'nop';

	constructor(options: NopConstructor<T, E>) {
		super(options);
	}
}
